import { render } from "./Instagram.vue?vue&type=template&id=adb07c5c"
const script = {}

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__